export default "__VITE_ASSET__pajHRVXnOSWhxJBd2$m8Fg__"